<template lang="html">
  <div>
    <v-form
      ref="approvalLevelForm"
    >
      <v-data-iterator
        :items="claimTypes"
        :hide-default-footer="true"
        disable-pagination
        item-key="id"
      >
        <template>
          <v-row>
            <v-col
              v-for="(claimType,index) in claimTypes"
              :key="index"
              cols="12"
              md="6"
            >
              <v-card class="mx-6">
                <v-card-title style="padding-top:0;padding-bottom:0;margin:0">
                  <span class="title v-label theme--light pt-3">{{ claimType.name }}</span>
                </v-card-title>

                <v-divider />
                <v-list
                  dense
                >
                  <v-list-item
                    class=""
                  >
                    <v-list-item-content
                      class="py-0"
                    >
                      Final Approver:
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-checkbox 
                        v-model="claimType.is_final_approver"
                      />
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </v-form>

    <v-card-actions>
      <v-spacer />
      <v-btn
        :disabled="progressing"
        text
        class="px-10"
        @click="closeDialog"
      >
        Close
      </v-btn>
      <v-btn
        v-if="$hasPermissionTo(['update job title approval level'])"
        :disabled="loading"
        :loading="progressing"
        color="hrissecondary"
        class="px-10 white--text"
        @click="submitForm"
      >
        Update
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
  export default {
    props: {
      position: { 
        type: Object,
        required: true,
      },
    },   
    data () {
      return {
        loading: false,
        progressing: false,
        claimTypes: [],                 
      }
    },
    watch: {     
      
    },
    created () {
      this.loading = true
      this.loadData()
    },
    methods: {
      closeDialog () {
        this.$emit('close-dialog')
      },
      loadData () {
        this.$http.all([
          this.$api.claimTypes().list(),
          this.$api.positionApproval().list(this.position.id, 'claim', 'authority'),
        ])
          .then(this.$http.spread((claimTypes, approvalAuthorities) => {
            this.claimTypes = claimTypes.data.map((claimType) => {
              return {
                id: claimType.id,
                name: claimType.name,
                is_final_approver: 0,
              }
            })

            approvalAuthorities.data.forEach((approvalAuthority) => {
              let activeLeaveTypeIndex = this.claimTypes.findIndex((p) => {
                if (!approvalAuthority.approvable) {
                  return false
                }
                
                return p.id === approvalAuthority.approvable_id
              })

              if (activeLeaveTypeIndex >= 0) {
                this.claimTypes[activeLeaveTypeIndex].is_final_approver = approvalAuthority.is_final_approver === 1
              }
            })

            this.loading = false
          }))
      },
      submitForm () {
        if (this.$refs.approvalLevelForm.validate()) {
          this.progressing = true
          this.$api.positionApproval().update(this.position.id, this.prepareFormData(), 'claim', 'authority')
            .then(response => {
              if (response.status === 200) {
                this.$snack({ message: response.data.status })
              }
            })
            .catch(error => {
              if (error.response.status === 422) {
                this.$snack({ 
                  color: 'error',
                  message: error.message, 
                })
              } else if (error.response.status === 405) {
                this.$dialog({
                  title: 'Unable to change authorize claim',
                  message: error.response.data.status, 
                  color: 'error',
                })
              }
            })
            .then(() => {
              this.progressing = false
            })
        }
      },
      prepareFormData () {
        return this.claimTypes.map((claimType) => {
          return {
            id: claimType.id,
            is_final_approver: claimType.is_final_approver === true ? 1 : 0,
          }
        })
      },
    }, 
  }
</script>

<style lang='css' scoped>
::v-deep .centered-input input {
    text-align: center
  }
</style>
